/* eslint-disable react/jsx-indent */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable max-len */
/* eslint-disable eqeqeq */
import  React from 'react'
import Button from 'react-bootstrap/Button'
import * as H from 'history'
import { ClaimController } from '../../controllers/ClaimController'
import { ClaimItem } from '../../models/ClaimItem'
import { ISupportSpinner } from '../../shared/Ajax'
import { ClaimList } from '../../models/ClaimList'
import { TableBody, TableColumn } from '../../shared/table'
import { Dialog } from '../../shared/Dialog'
import { ClaimYear } from '../../models/ClaimYear'
import { Backdrop } from '../../shared/Backdrop'
import { TimeoutPopup } from '../../shared/TimeoutPopup'
import { TextField } from '../../shared/fields'

interface DashboardFormsPageProps {
    history: H.History
}

interface DashboardFormsPageState extends ClaimList {
    loading: boolean
    searchTxt: string
    dialog: boolean
}

export class DashboardFormsPage extends React.Component<DashboardFormsPageProps, DashboardFormsPageState> implements ISupportSpinner {
    ajax: ClaimController
    firstYearLink: HTMLAnchorElement
    constructor(props: DashboardFormsPageProps) {
      super(props)

      this.ajax = new ClaimController()

      this.state = {
        items: [],
        years: [],
        loading: false,
        searchTxt: '',
        dialog: false,
      }
    }

    componentDidMount() {
      this.ajax.getList(this, (d) => {
        this.setState({ items: d.items.sort((a, b) => this.sortClaims(a, b)), years: d.years })
      })
    }

    componentWillUnmount() {
      this.ajax.cancel()
    }

    toggleSpinner(on: boolean, callback: { (): any }): void {
      this.setState({ loading: on }, callback)
    }

    sortClaims = (a: ClaimItem, b: ClaimItem): number => {
      const yearDif = b.year - a.year

      if (yearDif == 0) {
        if (a.account < b.account) return -1
        return 1
      }

      return yearDif
    }

    newClaim = (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault()
      if (this.state.years.length == 0) {
        return
      }

      if (this.state.years.length == 1) {
        this.openClaim(this.state.years[0])
      } else {
        this.setState({ dialog: true }, () => {
          if (this.firstYearLink) {
            this.firstYearLink.focus()
          }
        })
      }
    }

    openClaim = (year: ClaimYear) => {
      if (year.claimId) {
        this.props.history.push(`/claim/${year.claimId}`)
      } else {
        this.setState({ dialog: false }, () => {
          this.ajax.create(this, year.value, (d) => {
            if (d) { this.props.history.push(`/claim/${d}`) }
          })
        })
      }
    }

    closeDialog = () => {
      this.setState({ dialog: false })
    }

    viewOrResume = (claimId: string) => {
      const claim = this.state.items.filter((c) => c.id == claimId)[0]

      if (claim.migrated) {
        if (claim.year < 2013) {
          return
        }

        window.open(`/api/claim/downloadCompletedApplication?claimId=${claimId}`, '_blank')
      } else {
        this.props.history.push(`/claim/${claimId}`)
      }
    }

    removeClaim = (claimId: string, name: string) => {
      if (!confirm(`Are you sure you want to delete this claim${name ? ` for: \n'${name}'` : ''}?`)) {
        return
      }
      this.ajax.deactivateClaim(this, claimId, (c) => {
        if (c) {
          this.setState({ items: this.state.items.filter((r) => r.id !== claimId) })
        }
      })
    }

    actionLinkText = (claimId: string): string => {
      45

      const claim = this.state.items.filter((c) => c.id == claimId)[0]

      if (!claim.migrated) {
        return claim.status == 'Draft' ? 'Resume' : 'View'
      }
      if (claim.year >= 2013) {
        return 'View'
      }

      return ''
    }

    render() {
      const columns: TableColumn<ClaimItem>[] = [
        { name: 'Year', content: (r) => r.year },
        { name: 'Organisation', content: (r) => r.account },
        { name: 'Contact', content: (r) => r.contact, responsive: 'md' },
        { name: 'Submitted By', content: (r) => r.owningContact, responsive: 'md' },
        { name: 'Status', content: (r) => r.status },
        { name: 'Outcome', content: (r) => r.outcome, responsive: 'md' },
        {
          name: '',
          content: (r) => (r.status === 'Draft'
            ? <a href="#" title="Delete" onClick={(e) => { this.removeClaim(r.id, r.account); e.preventDefault() }}><span className="far fa-trash-alt" style={{ fontSize: '18px', color: 'red' }} /></a>
            : <span className="far fa-trash-alt" style={{ fontSize: '18px', color: 'grey' }} />),
        },
        {
          name: '', content: (r) => <a href="#" onClick={(e) => { e.preventDefault(); this.viewOrResume(r.id) }}>{this.actionLinkText(r.id)}</a>,
        },
      ]

      return (
        <div className="container-fluid pt-5">
          <h2>My Claims Applications</h2>

          <div className="emdg-callout my-4 mb-5">
            <div className="row">

              <div className="col-md-7">
                <p className="mb-2">Search</p>
                <TextField label="" asYouType id="txtSearch" block value={this.state.searchTxt} onChange={(e) => this.setState({ searchTxt: e })} />
              </div>

            {/* TODO REMOVE THIS FOR REFOCUS
              <div style={{ textAlign: 'center' }} className="col-md-1 align-self-center">
                <h3 className="mt-3">or</h3>
              </div>

              <div className="col-md-3">
                <p className="mb-2">&nbsp;</p>
                <Button className="emdg-btn" id="btnStartApplication" onClick={this.newClaim} disabled={this.state.years.length == 0 || this.state.years.some((x) => x.claimStatus && x.claimStatus != 'Draft')}>
                  {this.state.years.length == 1 && this.state.years[0].claimId ? 'Resume application' : 'Start new application'}
                </Button>
              </div>
              */}

            </div>
          </div>

          <TableBody<ClaimItem>
            id="claims"
            columns={columns}
            value={this.state.items.filter((r) => `${r.year} ${r.account} ${r.contact} ${r.owningContact} ${r.status} ${r.outcome}`.toLowerCase().indexOf(this.state.searchTxt.toLowerCase()) >= 0)}
            noRowsMessage={this.state.loading ? 'Loading' : 'No grant history found'}
            alwaysShowAllRows
            allowEdit
          />

          <Dialog
            id="years"
            title="Grant year"
            open={this.state.dialog}
            onClose={this.closeDialog}
            footer={<Button id="btnClose" className="emdg-btn emdg-btn--secondary" onClick={this.closeDialog}>Close</Button>}
          >
            <p>Please select a grant year.</p>
            <ul className="list-unstyled">
              {this.state.years.map((d, i) => (
                <li key={d.value}>
                  <a href="#" onClick={(e) => { e.preventDefault(); this.openClaim(d) }} ref={(r) => { if (i == 0) this.firstYearLink = r }}>
                    {d.label}
                    {' '}
                    {d.claimId ? ' - Resume' : ''}
                  </a>
                </li>
              ))}
            </ul>
          </Dialog>

          <Backdrop on={this.state.loading} />
          <TimeoutPopup />
        </div>
      )
    }
}
